import { SVGProps } from "react";

const AnotherSolutionIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 335.31 114.7"
        {...props}
    >
        <defs>
            <style>{".cls-3{stroke-width:0;fill:#fff}"}</style>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
            <path
                d="M332.94 24.69c-2.01-2.43-5.01-3.77-8.45-3.77H116.1l-2.14-11.35c-1.05-5.54-5.9-9.56-11.54-9.56H43.01c-4.14 0-8.02 2.22-10.12 5.79L1.64 58.91c-2.8 4.77-1.94 10.74 2.09 14.52l40.63 38.08c2.25 2.11 5.12 3.19 8.02 3.19 2.29 0 4.6-.68 6.63-2.06l15.92-10.85h234.18c7.02 0 13.84-5.7 15.19-12.71l10.77-55.06c.68-3.52-.07-6.83-2.13-9.32Z"
                style={{
                    fill: "#231f20",
                    strokeWidth: 0,
                }}
            />
            <path
                d="m45.86 60.65-8.73 30.88 13.91 13.12 9.22-43.91h36.9C90.25 65.51 59.5 86.29 59.5 86.29l-3.97 18.31s38.76-25.92 57.07-38.53c.74-.51.87-.93.74-1.65-1.06-5.73-2.09-11.46-3.08-17.21-.13-.77-.45-1.04-1.29-1.04-2.63.01-26.5.02-26.5.02 1.44-7.45 2.86-14.74 4.28-22.1.94 0 1.45-.02 2.62-.02 1 0 1.43.23 1.58 1.22.51 3.32 1.18 6.59 1.74 9.9.12.69.37.96 1.14.96 4.45-.04 14.39-.04 14.39-.04l-5.23-26.42H75.47l-7.5 36.49h-4.88l7.92-36.5s-18.59-.16-28.6-.21c0 0-27.39 47.51-32.51 56.62l10.14 9.49 7.53-14.84.03-.07m12.53-21.11c2.74-4.84 5.49-9.68 8.21-14.53.38-.67.73-.96 1.52-.96 1.09 0 1.96.02 3.02.02-1.43 7.39-2.84 14.67-4.27 22.03h-12.2c1.28-2.26 2.5-4.41 3.72-6.56Z"
                style={{
                    strokeWidth: 0,
                    fill: "#e52526",
                }}
            />
            <path
                d="M152.62 76.96c1.75-8.18 4.69-22.07 6.53-30.26h-.74c-4.32 15.08-11.86 41.02-12.88 45.15h-10.39c1.29-8.64 4.69-33.66 6.25-45.43h-.74c-1.47 7.27-3.77 19.5-5.98 30.07l-3.22 15.36H118.3l12.97-61.25h19.5c-.55 5.7-2.12 19.59-3.22 26.95h.46c2.67-8.64 4.23-14.44 8.18-26.95h20.23l-12.97 61.25h-13.98l3.13-14.9ZM201 65.74h-11.96l-2.94 14.53h14.16l-3.68 11.59h-27.22l12.97-61.25h26.85L206.7 42.2h-12.51l-2.67 11.86h11.96L201 65.74ZM221.69 66.02l-5.52 25.84h-14.25l12.97-61.25h17.01c11.04 0 14.99 5.89 12.78 16.09l-.92 4.23c-1.29 5.98-4.05 9.01-7.54 10.12 3.5 2.12 4.14 5.43 2.12 14.35-1.66 7.27-3.13 14.07-3.31 16.46h-13.89c-.46-1.1.28-5.43 3.22-19.31 1.29-6.07.46-6.53-1.93-6.53h-.74Zm2.3-10.4h1.1c2.76 0 3.5-1.01 4.32-4.87l1.01-5.15c.74-3.59.18-4.6-2.57-4.6h-.83l-3.04 14.62ZM277.51 69.14l-1.2 5.61c-2.02 9.47-4.6 18.03-18.67 18.03-10.02 0-17.11-3.31-13.89-18.39l5.98-28.33c2.76-13.15 8.65-16.37 18.3-16.37 15.54 0 15.73 10.21 14.16 17.2l-1.1 5.43h-14.16l1.66-7.82c.55-2.48.28-3.86-1.47-3.86-1.47 0-2.12.92-2.76 3.86l-6.99 33.11c-.64 3.13-.37 4.14 1.1 4.14 1.66 0 2.39-1.1 3.13-4.41l1.75-8.18h14.16ZM290.66 30.61h14.35l-4.97 23.45h4.32l4.97-23.45h14.53l-12.97 61.25h-14.53l5.52-26.12h-4.32l-5.52 26.12h-14.35l12.97-61.25Z"
                className="cls-3"
            />
        </g>
    </svg>
)

export default AnotherSolutionIcon
